/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiGreetingsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор шаблона")
    })

/**
 * @description Шаблон удален
 */
export const deleteApiGreetingsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiGreetingsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiGreetingsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiGreetingsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Шаблон приветственного экрана не найден
 */
export const deleteApiGreetingsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiGreetingsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiGreetingsIdMutationResponseSchema = z.lazy(() => deleteApiGreetingsId200Schema)